import requests from "./request.js";
const https = {
  post: (url, params, query) => {
    if (!query) {
      query = "";
    }
    return requests({
      url: url,
      method: "post",
      data: params,
      params:query,
    });
  },
  get: (url, params) => {
    if (!params) {
      return requests({
        url: url ,
        method: "get",
      });
    }else{
      return requests({
        url: url + params,
        method: "get",
      });
    }
  },
  put: (url, params) => {
    return requests({
      url: url,
      method: "put",
      data: params,
    });
  },
  del: (url, params) => {
    return requests({
      url: url + params,
      method: "delete",
    });
  },
};
export default https;
